import { PropertySpec } from '../../../properties/spec/property-spec'
import { ItemSortSpec } from './items/item-sort-spec'
import { DynamicPropertySpec } from '../../../properties/dynamic/dynamic-property-spec'
import { ConstraintSpec } from '../../../process/capability-spec/constraints/constraint-spec'

export class WorkCenterType {
  public id: string
  public abbreviation: string
  public name: string
  public description: string

  public capabilitySpecIds: string[]

  public propertySpecs: PropertySpec[]

  public dynamicPropertySpecs: DynamicPropertySpec[]

  public itemSortSpec: ItemSortSpec = new ItemSortSpec()

  public filterSpecs: ConstraintSpec[]
}
